<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" color="#00486b">
      <label>
        Snippet added to clipboard
      </label>
      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <v-overlay
          absolute
          :value="dialog"
        >
        <div class='card-container'>
          <v-card max-width='600' align-center justify-center>
            <v-card-title>
              Iframe Snippet
            </v-card-title>
            <v-card-text id="iframeCode">
              {{ snippet }}
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="#f0ad4e" text @click="dialog = false;">
                Close
              </v-btn>
              <v-btn color="#5bc0de" text @click="copyIframeCode">
                Copy
              </v-btn>
            </v-card-actions>
          </v-card>
        </div>
    </v-overlay>
    <v-btn
      rounded
      color="#00486b"
      style="color:#fff"
      width="7em"
      class="spacing"
      dark
      depressed
      @click='dialog = true'
    >
      Embed
    </v-btn>
  </div>
</template>

<script>
export default {
  props: {
    src: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: '',
    },
    width: {
      type: Number,
      default: 0,
    },
    height: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      dialog: false,
      snackbar: false,
    };
  },
  computed: {
    snippet() {
      const src = `<iframe
            id="${this.id}"
            src="${process.env.VUE_APP_SUBDOMAIN + this.src}"
            frameborder="0"
            scrolling="no"
            width="${this.width}px"
            height="${this.height}px"
          ></iframe>`;
      return src.toString();
    },
  },
  methods: {
    copyIframeCode() {
      const code = document.getElementById('iframeCode');
      const textArea = document.createElement('textarea');
      textArea.value = code.innerText;
      textArea.setAttribute('readonly', '');
      textArea.style.position = 'absolute';
      textArea.style.left = '-9999px';
      document.body.appendChild(textArea);
      textArea.select();
      textArea.setSelectionRange(0, 99999);

      if (!navigator.clipboard) {
        // use old commandExec() way
        document.execCommand('copy');
      } else {
        const text_to_copy = textArea.value;
        navigator.clipboard.writeText(text_to_copy).then(
          () => {
            document.body.removeChild(textArea);
            this.dialog = false;
            this.snackbar = true; // success
          }
        )
          .catch(
            () => {
              console.error('text could not be copied to clipboard'); // error
              document.body.removeChild(textArea);
              this.dialog = false;
            }
          );
      }
    },
  },
};
</script>

<style>
.card-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.primary-title {}
</style>
